import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Islamic-themed 404 Not Found page.
 * Renders for unknown routes instead of redirecting to login.
 */
const NotFoundScreen = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 py-12">
      {/* Islamic gradient background */}
      <div
        className="relative w-full max-w-md rounded-2xl shadow-xl overflow-hidden"
        style={{
          background: 'linear-gradient(145deg, #ecfdf5 0%, #d1fae5 50%, #a7f3d0 100%)',
          border: '2px solid #6ee7b7',
        }}
      >
        {/* Decorative corner pattern */}
        <div className="absolute top-0 right-0 w-24 h-24 opacity-20">
          <svg viewBox="0 0 100 100" className="w-full h-full text-emerald-600">
            <path
              d="M0 0 L100 0 L100 100 L0 100 Z M10 10 L90 10 L90 90 L10 90 Z M20 20 L80 20 L80 80 L20 80 Z"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
            />
            <path d="M50 30 L70 50 L50 70 L30 50 Z" fill="currentColor" opacity="0.3" />
          </svg>
        </div>

        <div className="relative p-8 text-center">
          {/* 404 display with Arabic-inspired styling */}
          <p
            className="text-7xl sm:text-8xl font-bold text-emerald-600/90 tracking-tight mb-2"
            style={{ fontFamily: "'Amiri', serif" }}
          >
            ٤٠٤
          </p>
          <p className="text-6xl font-black text-emerald-500/70 -mt-2 mb-2">404</p>

          {/* Bismillah */}
          <p
            className="text-lg text-emerald-700/90 mb-4 arabic-text"
            style={{ fontFamily: "'Amiri', serif" }}
          >
            بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيمِ
          </p>

          <h1 className="text-xl font-bold text-gray-800 mb-2">Halaman Tidak Ditemukan</h1>
          <p className="text-gray-600 text-sm mb-6">
            Halaman yang Anda cari mungkin telah dipindahkan atau tidak tersedia.
          </p>

          {/* Islamic verse */}
          <blockquote className="bg-white/60 rounded-xl p-4 border border-emerald-200/80 mb-6 text-left">
            <p className="text-sm text-gray-700 italic">
              &ldquo;Barangsiapa yang beriman kepada Allah dan hari akhir, hendaklah berkata baik atau diam.&rdquo;
            </p>
            <cite className="text-xs text-emerald-700 mt-1 block">— HR. Bukhari & Muslim</cite>
          </blockquote>

          <Link
            to="/beranda"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-600 to-teal-600 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Kembali ke Beranda
          </Link>
        </div>

        {/* Bottom ornament */}
        <div className="flex items-center justify-center gap-3 py-4 border-t border-emerald-200/80">
          <div className="w-12 h-px bg-emerald-300" />
          <span className="text-emerald-500 text-xs">Mosqify</span>
          <div className="w-12 h-px bg-emerald-300" />
        </div>
      </div>
    </div>
  );
};

export default NotFoundScreen;
